import ServiceExec from '@/common/utils/ServiceExec';
import { productCategory, common } from '@/common/service/ApiList';
import { updateToast, insertToast, removeToast } from '@/common/utils/ToastServiceResult';
import { assist } from '@/common/utils/ParameterAssistant';
import { asFormData } from '@/common/utils/ServiceSupport';

const { getList, detail, save, remove, update } = productCategory;

export default {
  FETCH_CATEGORIES: async ({ state, commit }, { params, page }) => {
    const { status, data } = await ServiceExec.get(getList, assist(params, page));
    if (status !== ServiceExec.status.OK) return;
    const { list, pageInfo } = data;
    commit('setList', list);
    commit('setPageInfo', pageInfo);
  },
  FETCH_MAIN_CATEGORIES: async ({ state, commit }, { params, page }) => {
    const { status, data } = await ServiceExec.get(getList, assist(params, page));
    if (status !== ServiceExec.status.OK) return;
    const { list, pageInfo } = data;
    commit('setMainList', list);
    commit('setMainPageInfo', pageInfo);
  },
  FETCH_CATEGORY: async ({ state, commit }, { productCategoryNo }) => {
    const { status, data } = await ServiceExec.get(detail(productCategoryNo));
    if (status !== ServiceExec.status.OK) return;
    commit('setDetail', data);
  },
  SAVE: async ({ state, commit }, productCategory) => {
    const request = { ...productCategory };
    delete request.management;
    const formData = asFormData(request);
    if (productCategory.management?.source === 'POS') {
      if (productCategory.categoryVn === '') formData.append('categoryVn', '');
      if (productCategory.categoryEn === '') formData.append('categoryEn', '');
    }
    const { status, data } = await ServiceExec.post(save, formData);
    if (productCategory.productCategoryNo > 0 && updateToast(status, data)) return true;
    else return !!(!productCategory.productCategoryNo && insertToast(status, data));
  },
  UPDATE: async ({ state, commit }, productCategory) => {
    const request = { ...productCategory };
    delete request.management;
    const { status, data } = await ServiceExec.post(update, asFormData(request));
    if (productCategory.productCategoryNo > 0 && updateToast(status, data)) return true;
    if (productCategory.isDelete  && removeToast(status, data)) return true;
  },
  REMOVE: async ({ state }, productCategoryNo) => {
    const { status, data } = await ServiceExec.delete(remove(productCategoryNo));
    return removeToast(status, data);
  },

  FETCH_CATEGORIES_ORDERS: async ({ state, commit }, storeNo) => {
    const { status, data } = await ServiceExec.get(productCategory.orders(storeNo));
    if (status !== ServiceExec.status.OK) return;

    return data;
  },

  SAVE_ORDER: async ({ state, commit }, orderList) => {
    const { status, data } = await ServiceExec.patch(productCategory.save_order, orderList);
    if (status !== ServiceExec.status.OK) return;

    updateToast(status, data);
  }
};
